import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import type {
	FrontendPlacementMessage,
	FrontendStage,
} from '@post-office/message-maker-browser/types';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--growth-transmuters/adminhub-billing-preview-footer-section';

import { AdminhubBillingPreviewTwcDiscoveryMessage } from './message';

import type { MessageFrontendProps } from './types';

const validateMessageFrontendProps = (input: unknown): MessageFrontendProps =>
	input as MessageFrontendProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: validateMessageFrontendProps,
		Component: AdminhubBillingPreviewTwcDiscoveryMessage,
	},
});
